/**
 * The single source of truth for the user-facing labels of the legal links,
 * in all four supported languages. Keyed by {@link LegalLanguage}.
 */
export const LEGAL_LABELS = {
    de: {
        impressum: 'Impressum',
        datenschutz: 'Datenschutzerklärung',
    },
    fr: {
        impressum: 'Mentions légales',
        datenschutz: 'Protection des données',
    },
    it: {
        impressum: 'Note legali',
        datenschutz: 'Protezione dei dati',
    },
    en: {
        impressum: 'Imprint',
        datenschutz: 'Privacy Policy',
    },
};
//# sourceMappingURL=legal_labels.js.map